module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_4.11e514d7.png";